export default __webpack_public_path__ + "static/other-235f11fca92f37e758bac6cb276183cb.jpg";